









































































import { Component, Vue, Watch } from 'vue-property-decorator'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import { routerPath, userType } from '@/app/model/store/domain/const'

@Component
export default class MachineManagerMenu extends Vue {
  private weedTotalCount: number = 0

  @Watch('$store.state.weedState.totalCountFlag')
  private onDataChange (flag: boolean) {
    if (flag) {
      const data = JSON.parse(Local.getWeedAlarmCount()!)
      this.weedTotalCount = data.total_count
      this.$store.commit('weedState/setTotalCountFlag', false)
    }
  }
  created () {
    const data = JSON.parse(Local.getWeedAlarmCount()!)
    if (data !== null) {
      this.weedTotalCount = data.total_count
    }
  }
}
